import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { CommunityType } from './types'

interface EditProps {
  community: CommunityType
}

export default function Edit({ community }: EditProps) {
  return (
    <>
      <Head title="Editing community" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing community</h1>

        <Form
          community={community}
          action={`/communities/${community.id}`}
          method="patch"
          submitText="Update Community"
        />

        <Link
          href={`/communities/${community.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Show this community
        </Link>
        <Link
          href="/communities"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to communities
        </Link>
      </div>
    </>
  )
}
